<template>
  <div>
    <a-tabs :default-active-key="hole.length ? hole[0] : ''">
      <a-tab-pane
        :key="o"
        :tab="o"
        v-for="(o, index) in hole"
        :forceRender="true"
      >
        <div
          :ref="`myEchart${index}`"
          class="myEchart"
          style="height: 500px; margin-top: 30px; margin-right: 20px"
        ></div>
      </a-tab-pane>
    </a-tabs>

    <div style="margin-bottom: 16px; width: 50%">
      <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `Selected ${selectedRowKeys.length} items` }}
        </template>
      </span>
    </div>
    <a-button @click="handleOk">download</a-button>
    <a-modal
      title="download"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-input v-model="downloadPassword" />
    </a-modal>
    <a-table
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :pagination="false"
      :columns="columns"
      :data-source="showdata"
      :scroll="{ x: 2400, y: 700 }"
    />
    <a-button
      class="reload-btn"
      type="primary"
      :disabled="!hasSelected"
      :loading="loading"
      @click="start"
    >
      Reload
    </a-button>
  </div>
</template>

<script>
import { addNumber, getStratigraphy } from '@/api/index';
import { getLabel, getSymbol, getStandard, getColor } from '@/utils/getLabel';
import * as echarts from 'echarts';
import ExportExcel from '@/utils/exportExcel';
const Standardcolumns = [
  {
    title: 'Leg_exp',
    dataIndex: 'leg_Exp',
    key: 'leg_Exp',
  },
  {
    title: 'Site',
    dataIndex: 'site',
    key: 'site',
  },
  {
    title: 'Hole',
    dataIndex: 'hole',
    key: 'hole',
  },
  {
    title: 'Chrono_Type',
    dataIndex: 'chrono_Type',
    key: 'chrono_Type',
  },
  {
    title: 'Event_Type',
    dataIndex: 'event_Type',
    key: 'event_Type',
  },
  {
    title: 'Event_Name',
    dataIndex: 'event_Name',
    key: 'event_Name',
  },
  {
    title: 'Depth_type',
    dataIndex: 'depth_Type',
    key: 'depth_Type',
  },
  {
    title: 'Depth',
    dataIndex: 'depth',
    key: 'depth',
    sorter: (a, b) => a.depth - b.depth,
  },
  {
    title: 'Bot_Depth',
    dataIndex: 'bot_Depth',
    key: 'bot_Depth',
  },
  {
    title: 'Top_Depth',
    dataIndex: 'top_Depth',
    key: 'top_Depth',
  },
  {
    title: 'Standard_Age',
    dataIndex: 'standard_Age',
    key: 'standard_Age',
  },
  {
    title: 'Standard',
    dataIndex: 'standard',
    // filters: [
    //   { text: 'GTS2020', value: 'GTS2020' },
    //   { text: 'GTS2012', value: 'GTS2012' },
    //   { text: 'TSC', value: 'TSC' },
    //   { text: 'NSB', value: 'NSB' },
    //   { text: 'Original', value: 'Original' },
    // ],
    // onFilter: (value, record) => {
    //   return record.standard.indexOf(value) === 0;
    // },
    key: 'standard',
  },
  {
    title: 'Age_Uncertainty',
    dataIndex: 'age_uncertainty',
    key: 'age',
  },
  {
    title: 'Bot_sample',
    dataIndex: 'bot_sample',
    key: 'bot_sample',
  },
  {
    title: 'Top_sample',
    dataIndex: 'top_sample',
    key: 'top_sample',
  },
  {
    title: 'Mikrotax(url)',
    dataIndex: 'mikrotax_url',
    key: 'mikrotax_url',
  },
  {
    title: 'Source',
    dataIndex: 'reference',
    key: 'reference',
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
  },
];
const Originalcolumns = [
  {
    title: 'Leg_exp',
    dataIndex: 'leg_Exp',
    key: 'leg_Exp',
  },
  {
    title: 'Site',
    dataIndex: 'site',
    key: 'site',
  },
  {
    title: 'Hole',
    dataIndex: 'hole',
    key: 'hole',
  },
  {
    title: 'Chrono_Type',
    dataIndex: 'chrono_Type',
    key: 'chrono_Type',
  },
  {
    title: 'Event_Type',
    dataIndex: 'event_Type',
    key: 'event_Type',
  },
  {
    title: 'Event_Name',
    dataIndex: 'event_Name',
    key: 'event_Name',
  },
  {
    title: 'Depth_type',
    dataIndex: 'depth_Type',
    key: 'depth_Type',
  },
  {
    title: 'Depth',
    dataIndex: 'depth',
    key: 'depth',
    sorter: (a, b) => a.depth - b.depth,
  },
  {
    title: 'Bot_Depth',
    dataIndex: 'bot_Depth',
    key: 'bot_Depth',
  },
  {
    title: 'Top_Depth',
    dataIndex: 'top_Depth',
    key: 'top_Depth',
  },
  // {
  //   title: 'Standard_Age',
  //   dataIndex: 'standard_age',
  //   key: 'standard_Age',
  // },
  // {
  //   title: 'Standard',
  //   dataIndex: 'standard',
  //   // filters: [
  //   //   { text: 'GTS2020', value: 'GTS2020' },
  //   //   { text: 'GTS2012', value: 'GTS2012' },
  //   //   { text: 'TSC', value: 'TSC' },
  //   //   { text: 'NSB', value: 'NSB' },
  //   //   { text: 'Original', value: 'Original' },
  //   // ],
  //   // onFilter: (value, record) => {
  //   //   return record.standard.indexOf(value) === 0;
  //   // },
  //   key: 'standard',
  // },
  {
    title: 'original_Age',
    dataIndex: 'original_Age',
    key: 'original_Age',
  },
  {
    title: 'Age_Uncertainty',
    dataIndex: 'age_uncertainty',
    key: 'age_Uncertainty',
  },
  {
    title: 'Bot_sample',
    dataIndex: 'bot_sample',
    key: 'bot_sample',
  },
  {
    title: 'Top_sample',
    dataIndex: 'top_sample',
    key: 'top_sample',
  },
  {
    title: 'Mikrotax(url)',
    dataIndex: 'mikrotax_url',
    key: 'mikrotax_url',
  },
  {
    title: 'Source',
    dataIndex: 'reference',
    key: 'reference',
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
  },
];
// const Scalecolumns = [
//   {
//     title: 'Leg_exp',
//     dataIndex: 'leg_Exp',
//     key: 'leg_Exp',
//   },
//   {
//     title: 'Site',
//     dataIndex: 'site',
//     key: 'site',
//   },
//   {
//     title: 'Hole',
//     dataIndex: 'hole',
//     key: 'hole',
//   },
//   {
//     title: 'Chrono_Type',
//     dataIndex: 'chrono_Type',
//     key: 'chrono_Type',
//   },
//   {
//     title: 'Event_Type',
//     dataIndex: 'event_Type',
//     key: 'event_Type',
//   },
//   {
//     title: 'Event_Name',
//     dataIndex: 'event_Name',
//     key: 'event_Name',
//   },
//   {
//     title: 'Depth_type',
//     dataIndex: 'depth_Type',
//     key: 'depth_Type',
//   },
//   {
//     title: 'Depth',
//     dataIndex: 'depth',
//     key: 'depth',
//     sorter: (a, b) => a.depth - b.depth,
//   },
//   {
//     title: 'Bot_Depth',
//     dataIndex: 'bot_Depth',
//     key: 'bot_Depth',
//   },
//   {
//     title: 'Top_Depth',
//     dataIndex: 'top_Depth',
//     key: 'top_Depth',
//   },

//   {
//     title: 'Age_Uncertainty',
//     dataIndex: 'age_uncertainty',
//     key: 'age_Uncertainty',
//   },
//   {
//     title: 'Bot_sample',
//     dataIndex: 'bot_sample',
//     key: 'bot_sample',
//   },
//   {
//     title: 'Top_sample',
//     dataIndex: 'top_sample',
//     key: 'top_sample',
//   },
//   {
//     title: 'Mikrotax(url)',
//     dataIndex: 'mikrotax_url',
//     key: 'mikrotax_url',
//   },
//   {
//     title: 'Source',
//     dataIndex: 'source',
//     key: 'source',
//   },
// ];
export default {
  name: 'stratlistName',

  data() {
    return {
      data: [],
      columns: Standardcolumns,
      selectedRowKeys: [], // Check here to configure the default column
      loading: false,
      str: '',
      showdata: [],
      standard: '',
      visible: false,
      confirmLoading: false,
      downloadPassword: '',
      echartsData: [],
    };
  },
  mounted() {
    // console.log(this.$route.query);
    // if (this.stratlist) {
    //   this.data = this.stratlist;
    //   this.str = ' ';
    // }
    // const Hole = this.$route.query.hole;
    // this.initEcharts();
    // this.$axios
    //   .get('http://1.14.92.14:8085/find_stratigraphic', {
    //     params: { Hole: this.hole },
    //   })
    //   .then((response) => {
    //     console.log(response);
    //     this.str = '';
    //     this.data = response.data;
    //   });
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  watch: {
    hole() {
      console.log(this.hole);
      getStratigraphy(this.hole).then((res) => {
        this.data = [];
        res.map((list) => {
          this.data = [...this.data, ...list.data];
        });
        console.log('this.data', this.data);
        // this.data = res.data;
        this.showdata = this.data.sort((a, b) => a.depth - b.depth);
        this.echartsData = res;
        // this.showdata = this.data.filter((item) => {
        //   return (
        //     item[getStandard(this.scale)] ||
        //     (this.scale == 'Standard' && item[getStandard(this.scale)])
        //   );
        //   // item.standard == this.scale && item[getStandard(item.standard)]
        // });
        // this.showdata.map((item) => {
        //   console.log(item);
        //   item.standard_age = item[getStandard(this.scale)];
        // });
        // console.log('this.showdata', this.showdata);
        this.standard = this.scale;
        this.initEcharts();
      });
    },
    scale() {
      // console.log('scaleChange');
      // this.columns = {};
      // this.columns = [
      //   {
      //     title: this.scale,
      //     dataIndex: getStandard(this.scale),
      //     key: getStandard(this.scale),
      //   },
      //   ...Scalecolumns,
      // ];
      if (this.scale == 'Standard') {
        this.columns = Standardcolumns;
      } else {
        this.columns = Originalcolumns;
      }
      if (!this.scale) {
        this.showdata = this.data.sort((a, b) => a.depth - b.depth);
        this.standard = '';
      } else {
        this.showdata = this.data.sort((a, b) => a.depth - b.depth);
        // this.showdata = this.data.filter((item) => {
        //   // return (
        //   //   item[getStandard(this.scale)] ||
        //   //   (this.scale == 'Standard' && item[getStandard(this.scale)])
        //   // );
        //   return item['standard'] || item['standard'];
        //   // item.standard == this.scale && item[getStandard(item.standard)]
        // });
        // this.showdata.map((item) => {
        //   console.log(item);
        //   item.standard_age = item[getStandard(this.scale)];
        // });
        console.log('this.showdata', this.showdata);
        this.standard = this.scale;
      }
      console.log(this.scale);

      this.initEcharts();
    },
    source() {
      console.log('source Change');
      if (this.source == 'Officail Publication') {
        console.log(
          'sta',
          this.data[0].raw_sources_for_statistic.includes('Offical publication')
        );

        this.showdata = this.data.filter((item) => {
          console.log('dsadsadasdas');
          // return true;
          return (
            item.raw_sources_for_statistic.includes('Officail Publication') ||
            item.raw_sources_for_statistic.includes('offical publication') ||
            item.raw_sources_for_statistic.includes('Offical publication') ||
            console.log(
              item.raw_sources_for_statistic.includes('Officail Publication'),
              item.raw_sources_for_statistic
            )
          );
        });
        this.showdata = this.showdata.sort((a, b) => a.depth - b.depth);
      } else if (this.source == 'all') {
        this.showdata = this.data.sort((a, b) => a.depth - b.depth);
      } else {
        this.showdata = this.data.filter((item) => {
          return item.raw_sources_for_statistic.includes(this.source);
        });
        this.showdata = this.showdata.sort((a, b) => a.depth - b.depth);
      }
      console.log('this.showdata', this.showdata);
      this.initEcharts();
    },
  },
  methods: {
    handleCarouselChange() {
      this.initEcharts();
    },
    start() {
      this.loading = true;
      // ajax request after empty completing
      setTimeout(() => {
        this.loading = false;
        this.selectedRowKeys = [];
      }, 1000);
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    initEcharts() {
      // var mychartMap = echarts.init(this.$refs.myEchart);
      // let Foraminifera = [];
      // let Calcareous = [];
      // let Radiolaria = [];
      // let Diatom = [];
      // let Radiometric = [];
      // let Magnetostratigraphy = [];
      // this.showdata.map((item) => {
      //   switch (item.chrono_Type) {
      //     case 'Bio_F':
      //       this.standard
      //         ? Foraminifera.push([
      //             item[getStandard(this.standard)],
      //             item.depth,
      //           ])
      //         : Foraminifera.push([item['standard_age'], item.depth]);

      //       break;
      //     case 'Bio_N':
      //       this.standard
      //         ? Foraminifera.push([
      //             item[getStandard(this.standard)],
      //             item.depth,
      //           ])
      //         : Foraminifera.push([item['standard_age'], item.depth]);

      //       Calcareous.push([item.age, item.depth]);
      //       break;
      //     case 'Bio_R':
      //       this.standard
      //         ? Foraminifera.push([
      //             item[getStandard(this.standard)],
      //             item.depth,
      //           ])
      //         : Foraminifera.push([item['standard_age'], item.depth]);

      //       Radiolaria.push([item.age, item.depth]);
      //       break;
      //     case 'Bio_D':
      //       this.standard
      //         ? Foraminifera.push([
      //             item[getStandard(this.standard)],
      //             item.depth,
      //           ])
      //         : Foraminifera.push([item['standard_age'], item.depth]);

      //       Diatom.push([item.age, item.depth]);
      //       break;
      //     case 'RD':
      //       this.standard
      //         ? Foraminifera.push([
      //             item[getStandard(this.standard)],
      //             item.depth,
      //           ])
      //         : Foraminifera.push([item['standard_age'], item.depth]);

      //       Radiometric.push([item.age, item.depth]);
      //       break;
      //     case 'M':
      //       this.standard
      //         ? Foraminifera.push([
      //             item[getStandard(this.standard)],
      //             item.depth,
      //           ])
      //         : Foraminifera.push([item['standard_age'], item.depth]);

      //       Magnetostratigraphy.push([item.age, item.depth]);
      //       break;
      //   }
      // });
      // console.log('this.echartsData', this.echartsData);
      this.echartsData.map((echartsItem, index) => {
        // console.log('ref', 'myEchart' + index, this.$refs['myEchart' + index]);
        this.$nextTick(() => {
          const mychartMap = echarts.init(this.$refs['myEchart' + index][0]);

          let series = echartsItem.data.map((item) => {
            console.log(
              'standard:',
              this.standard,
              'get',
              getStandard(this.standard),
              item[getStandard(this.standard)]
            );
            return {
              name: getLabel(item.chrono_Type), // 是否显示左上角图例
              type: 'scatter',
              symbol: getSymbol(item.chrono_Type),
              symbolSize: 7, // 点位大小
              itemStyle: {
                color: getColor(item.chrono_Type), // 各个点位的颜色设置
                borderWidth: 2,
                borderType: 'solid',
                // opacity: 0, // 透明度
                // color: 'white',
                borderColor: 'black',
              },
              tooltip: {
                formatter: function (e) {
                  return `age：  ${e.value[0]}, depth：  ${e.value[1]}`;
                },
              },
              data: [
                [
                  this.scale == 'Standard'
                    ? item['standard_Age']
                    : item['original_Age'],
                  item.depth,
                ],
                // this.standard
                //   ? [item[getStandard(this.standard)], item.depth]
                //   : [item['standard_age'], item.depth],
              ], // 数据来源
            };
          });
          let option = {
            title: {
              text: 'Age Depth Relation',
              left: 100,
            },
            tooltip: {
              trigger: 'item',
            },
            legend: {
              type: 'plain',
            },
            yAxis: {
              type: 'value',
              inverse: 'false',
              name: 'Depth(m)',
              max: function (value) {
                return Math.ceil(value.max) + 1;
              },
              nameLocation: 'center',
              nameTextStyle: {
                padding: 20,
                fontSize: 20,
              },
              min: function (value) {
                return Math.floor(value.min) - 1 < 0
                  ? 0
                  : Math.floor(value.min) - 1;
              },
            },
            xAxis: {
              type: 'value',
              name: 'Age(Ma)',
              nameLocation: 'center',
              nameTextStyle: {
                padding: 20,
                fontSize: 20,
              },
              min: function (value) {
                console.log(value);
                return Math.ceil(value.min - 1) < 0
                  ? 0
                  : Math.ceil(value.min - 1);
              },
              max: function (value) {
                return Math.floor(value.max + 1);
              },
            },
            series: series,
          };
          if (option && typeof option === 'object') {
            mychartMap.setOption(option, true);
            console.log(option);
          }
          window.onresize = mychartMap.resize;
        });
      });
      // let series = this.showdata.map((item) => {
      //   console.log(
      //     'standard:',
      //     this.standard,
      //     'get',
      //     getStandard(this.standard),
      //     item[getStandard(this.standard)]
      //   );
      //   return {
      //     name: getLabel(item.chrono_Type), // 是否显示左上角图例
      //     type: 'scatter',
      //     symbol: getSymbol(item.chrono_Type),
      //     symbolSize: 7, // 点位大小
      //     itemStyle: {
      //       color: getColor(item.chrono_Type), // 各个点位的颜色设置
      //       borderWidth: 2,
      //       borderType: 'solid',
      //       // opacity: 0, // 透明度
      //       // color: 'white',
      //       borderColor: 'black',
      //     },
      //     tooltip: {
      //       formatter: function (e) {
      //         return `age：  ${e.value[0]}, depth：  ${e.value[1]}`;
      //       },
      //     },
      //     data: [
      //       [
      //         this.scale == 'Standard'
      //           ? item['standard_Age']
      //           : item['original_Age'],
      //         item.depth,
      //       ],
      //       // this.standard
      //       //   ? [item[getStandard(this.standard)], item.depth]
      //       //   : [item['standard_age'], item.depth],
      //     ], // 数据来源
      //   };
      // });
      // console.log(series);
      // let option = {
      //   title: {
      //     text: 'Age Depth Relation',
      //     left: 100,
      //   },
      //   tooltip: {
      //     trigger: 'item',
      //   },
      //   legend: {
      //     type: 'plain',
      //   },
      //   yAxis: {
      //     type: 'value',
      //     inverse: 'false',
      //     name: 'Depth(m)',
      //     max: function (value) {
      //       return Math.ceil(value.max) + 1;
      //     },
      //     nameLocation: 'center',
      //     nameTextStyle: {
      //       padding: 20,
      //       fontSize: 20,
      //     },
      //     min: function (value) {
      //       return Math.floor(value.min) - 1 < 0
      //         ? 0
      //         : Math.floor(value.min) - 1;
      //     },
      //   },
      //   xAxis: {
      //     type: 'value',
      //     name: 'Age(Ma)',
      //     nameLocation: 'center',
      //     nameTextStyle: {
      //       padding: 20,
      //       fontSize: 20,
      //     },
      //     min: function (value) {
      //       console.log(value);
      //       return Math.ceil(value.min - 1) < 0 ? 0 : Math.ceil(value.min - 1);
      //     },
      //     max: function (value) {
      //       return Math.floor(value.max + 1);
      //     },
      //   },
      //   series: series,
      // };
      // if (option && typeof option === 'object') {
      //   mychartMap.setOption(option, true);
      //   console.log(option);
      // }
      // window.onresize = mychartMap.resize;
    },
    toExcel() {
      ExportExcel(this.columns, this.showdata, 'sedst');
    },
    handleSearchHoleByName(value) {
      console.log(value);
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      // if (this.downloadPassword !== 'Malabcode') {
      //   this.$message.error('Code Error！');
      //   return;
      // }
      addNumber();
      this.confirmLoading = true;
      this.toExcel();
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel() {
      this.visible = false;
    },
  },
  props: ['hole', 'scale', 'source'],
};
</script>

<style scoped>
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: fit-content;
  line-height: 160px;
  overflow: hidden;
}

.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #2e2a2a;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
</style>
